import { memo } from 'react';

interface DeleteTrashIconProperties {
  width?: number;
  height?: number;
}

const DeleteTrashIcon = memo(({ width = 17, height = 17 }: DeleteTrashIconProperties) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 17 17'
      fill='none'
      aria-hidden
      focusable='false'
    >
      <path
        d='M15.3498 3.13315C15.3498 2.5577 14.9066 2.09121 14.3599 2.09121H11.8681C11.4512 0.845989 10.335 0.0115571 9.08074 0.00732422H7.10105C5.84676 0.0115571 4.73062 0.845989 4.31365 2.09121H1.82187C1.2752 2.09121 0.832031 2.5577 0.832031 3.13315C0.832031 3.70859 1.2752 4.17509 1.82187 4.17509H2.15183V12.8579C2.15183 14.9679 3.77679 16.6784 5.78125 16.6784H10.4005C12.405 16.6784 14.03 14.9679 14.03 12.8579V4.17509H14.3599C14.9066 4.17509 15.3498 3.70859 15.3498 3.13315ZM12.0503 12.8579C12.0503 13.817 11.3117 14.5945 10.4005 14.5945H5.78125C4.87013 14.5945 4.13152 13.817 4.13152 12.8579V4.17509H12.0503V12.8579Z'
        fill='#FE552F'
      />
      <path
        d='M6.4415 12.5073C6.98818 12.5073 7.43135 12.0408 7.43135 11.4653V7.29756C7.43135 6.72211 6.98818 6.25562 6.4415 6.25562C5.89483 6.25562 5.45166 6.72211 5.45166 7.29756V11.4653C5.45166 12.0408 5.89483 12.5073 6.4415 12.5073Z'
        fill='#FE552F'
      />
      <path
        d='M9.74229 12.5073C10.289 12.5073 10.7321 12.0408 10.7321 11.4653V7.29756C10.7321 6.72211 10.289 6.25562 9.74229 6.25562C9.19561 6.25562 8.75244 6.72211 8.75244 7.29756V11.4653C8.75244 12.0408 9.19561 12.5073 9.74229 12.5073Z'
        fill='#FE552F'
      />
    </svg>
  );
});

DeleteTrashIcon.displayName = 'DeleteTrashIcon';

export default DeleteTrashIcon;
